import { defineComponent as r, renderSlot as t } from "vue";
import { provideThemeConfig as p } from "./context.js";
const i = /* @__PURE__ */ r({
  __name: "v-theme-provider",
  props: {
    theme: {}
  },
  setup(e) {
    return p(e.theme), (o, n) => t(o.$slots, "default");
  }
});
export {
  i as default
};
